import { Card, Button, Table, Space, Image, Flex } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useDeleteAdvertMutation, useFetchAdvertQuery } from "./advert.service";
import { BACKEND_URL } from "../../constant";

const AdvertPage = () => {
  const navigate = useNavigate();

  const {
    data = {
      data: {
        adverts: [],
      },
    },
    isLoading,
    isSuccess,
  } = useFetchAdvertQuery();

  const {
    data: { adverts },
  } = data;

  const [requestDeleteAdvert, { isLoading: isDeleteLoading }] =
    useDeleteAdvertMutation();

  const columns = [
    {
      title: "#",
      dataIndex: "key",
      render: (text, record, index) => index + 1,
      width: "5%",
    },
    {
      title: "Title",
      dataIndex: "title",
      render: (text) => <span>{text.default}</span>,
    },
    {
      title: "Image",
      dataIndex: "imageUrl",
      render: (text) => (
        <Image
          width={200}
          height={150}
          src={`${BACKEND_URL}${text}`}
          alt="Uploaded advert image"
          style={{
            objectFit: "cover",
            border: "1px solid #d9d9d9",
            borderRadius: "6px",
          }}
        />
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space size="middle">
          <Button
            type="primary"
            icon={<EditOutlined />}
            size="small"
            onClick={() => navigate(`/advert/edit/${record._id}`)}
          >
            Edit
          </Button>
          <Button
            type="default"
            color="danger"
            variant="solid"
            icon={<DeleteOutlined />}
            size="small"
            loading={isDeleteLoading}
            onClick={() => requestDeleteAdvert(record._id)}
          >
            Delete
          </Button>
        </Space>
      ),
      width: "15%",
    },
  ];

  return (
    <Card
      title="Advert List"
      style={{ fontSize: "20px" }}
      extra={
        <Flex justify="center">
          <Button
            onClick={() => navigate("/advert/create")}
            type="primary"
            disabled={adverts.length > 0 ? true : false}
          >
            Create
          </Button>
        </Flex>
      }
      bordered={false}
    >
      <Table columns={columns} dataSource={adverts} rowKey="key" />
    </Card>
  );
};

export default AdvertPage;
